<div class="main-content">
	<div class="container-fluid">
		<div class="page-card card">

			<div class="card-header card-header-{{color}}-6">
				<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Create User</h4>
				<div class="card-category card-category-actions">
					<button mat-stroked-button (click)="back()">Cancel</button>
					<button mat-raised-button color="primary" class="create-btn"
								[disabled]="loading || !userForm.valid || !systemForm.valid || user.locations.length < 1 || activeStep !== 2 || (isSalespersonSetupMode && !selectedSalespersonManufacturerId)"
								(click)="createUser()">
							<mat-spinner *ngIf="loading" diameter="18" strokeWidth="3"></mat-spinner>
							<span *ngIf="!loading">Create User</span>
					</button>
				</div>
			</div>

			<div class="page-body">
				<div class="stepper-col">
					<div class="account-type-row mb-3" *ngIf="isMoovSetup">
						<p class="subsection-label mb-2">Account type</p>
						<mat-button-toggle-group [(ngModel)]="accountType" [ngModelOptions]="{standalone: true}" (change)="onAccountTypeChange()">
							<mat-button-toggle value="internal">Internal user</mat-button-toggle>
							<mat-button-toggle value="salesperson">Brand salesperson</mat-button-toggle>
						</mat-button-toggle-group>
						<p class="small text-muted mt-2 mb-0" *ngIf="isSalespersonSetupMode">
							Creates a salesperson login for the admin app and the sales portal (www_users + salesman + brand scope) in one save.
						</p>
					</div>

					<div class="card mb-3" *ngIf="isSalespersonSetupMode">
						<div class="card-header">Brand</div>
						<div class="card-body">
							<mat-form-field appearance="outline" class="field-full">
								<mat-label>Brand</mat-label>
								<mat-select [(ngModel)]="selectedSalespersonManufacturerId" [ngModelOptions]="{standalone: true}" (selectionChange)="onSalespersonBrandChange($event.value)" required>
									<mat-option *ngFor="let b of salespersonBrands" [value]="b.manufacturer_id">
										{{ b.brand_name }} ({{ b.supplier_id }})
									</mat-option>
								</mat-select>
								<mat-hint *ngIf="!salespersonBrands.length">All configured brands already have a salesperson login.</mat-hint>
							</mat-form-field>
							<p class="small text-muted mb-0" *ngIf="selectedSalespersonBrand as brand">
								Sales code: <strong>{{ systemForm.get('salesman')?.value }}</strong>
								· Supplier: <strong>{{ brand.supplier_name }}</strong>
							</p>
						</div>
					</div>

					<mat-stepper orientation="vertical" linear (selectionChange)="logStep($event)">

						<!-- Step 1: User Information -->
						<mat-step [stepControl]="userForm">
							<ng-template matStepLabel>User Information</ng-template>
							<form [formGroup]="userForm" class="step-form">
								<mat-form-field appearance="outline" class="field-full">
									<mat-label>Full Name</mat-label>
									<input matInput formControlName="realname">
									<mat-error *ngIf="userForm.get('realname').hasError('required')">Required</mat-error>
								</mat-form-field>

								<div class="field-row">
									<mat-form-field appearance="outline">
										<mat-label>Email Address</mat-label>
										<input matInput type="email" formControlName="email" placeholder="user@example.com">
										<mat-error *ngIf="userForm.get('email').hasError('pattern')">Invalid email</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline">
										<mat-label>Phone</mat-label>
										<input matInput type="text" (input)="format_phone($event.target)" formControlName="phone" placeholder="(123) 456-7890">
									</mat-form-field>
								</div>

								<mat-form-field appearance="outline" class="field-full">
									<mat-label>User ID</mat-label>
									<input matInput formControlName="userid" placeholder="e.g. jsmith">
									<button mat-icon-button matSuffix type="button" (click)="suggestUseridFromName()" matTooltip="Generate from Full Name" [disabled]="!userForm.get('realname').value">
										<mat-icon>auto_fix_high</mat-icon>
									</button>
									<mat-hint *ngIf="useridTakenSuggest">{{ useridTakenSuggest }}</mat-hint>
									<mat-error *ngIf="userForm.get('userid').hasError('required')">Required</mat-error>
									<mat-error *ngIf="userForm.get('userid').hasError('pattern')">Letters, numbers, - and _ only</mat-error>
									<mat-error *ngIf="userForm.get('userid').hasError('taken')">Already in use. Try "{{ useridTakenSuggest }}"</mat-error>
								</mat-form-field>

								<mat-form-field appearance="outline" class="field-full">
									<mat-label>Password</mat-label>
									<input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
									<button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" matTooltip="{{ hidePassword ? 'Show password' : 'Hide password' }}">
										<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
									</button>
									<button mat-icon-button matSuffix type="button" (click)="generatePassword()" matTooltip="Generate password">
										<mat-icon>vpn_key</mat-icon>
									</button>
									<mat-error *ngIf="userForm.get('password').hasError('required')">Required</mat-error>
								</mat-form-field>
							</form>
							<div class="step-actions">
								<button mat-raised-button color="primary" matStepperNext [disabled]="!userForm.valid">Next</button>
							</div>
						</mat-step>

						<!-- Step 2: System Information -->
						<mat-step [stepControl]="systemForm">
							<ng-template matStepLabel>System Information</ng-template>
							<form [formGroup]="systemForm" class="step-form">

								<div class="field-row">
									<mat-form-field appearance="outline">
										<mat-label>Default Location</mat-label>
										<mat-select formControlName="defaultlocation" (selectionChange)="defaultLocation($event)">
											<mat-option *ngFor="let loc of recs" [value]="loc.loccode">{{ loc.loccode }} – {{ loc.locationname }}</mat-option>
										</mat-select>
										<mat-error>Required</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline">
										<mat-label>User Group</mat-label>
										<mat-select formControlName="user_group">
											<mat-option *ngFor="let ug of usergroups" [value]="ug.user_group_id">{{ ug.name }}</mat-option>
										</mat-select>
										<mat-error>Required</mat-error>
									</mat-form-field>
								</div>

								<div class="field-row">
									<mat-form-field appearance="outline">
										<mat-label>Access Level</mat-label>
										<mat-select formControlName="fullaccess">
											<mat-option *ngFor="let level of accessLevels" [value]="level.value">{{ level.name }}</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field appearance="outline">
										<mat-label>Department</mat-label>
										<input matInput formControlName="department" placeholder="e.g. Accounting">
									</mat-form-field>
								</div>

								<mat-form-field *ngIf="canEditAllowedClientConfigs && !isSalespersonSetupMode" appearance="outline" class="field-full">
									<mat-label>Allowed app setups (config switcher)</mat-label>
									<mat-select formControlName="allowedUiConfigs" multiple>
										<mat-option *ngFor="let opt of allowedUiConfigOptions" [value]="opt.config">
											{{ opt.customerName }}<ng-container *ngIf="opt.label"> ({{ opt.label }})</ng-container>
										</mat-option>
									</mat-select>
									<mat-hint>Leave empty for no restriction. You can only assign setups you are allowed to use (level 5+).</mat-hint>
								</mat-form-field>

								<div class="toggles-row" *ngIf="!isSalespersonSetupMode">
									<mat-slide-toggle formControlName="isPOSUser" color="primary">POS User</mat-slide-toggle>
									<mat-slide-toggle formControlName="isSalesman" color="primary">Salesman</mat-slide-toggle>
								</div>

								<mat-form-field *ngIf="systemForm.get('isPOSUser')?.value && !isSalespersonSetupMode" appearance="outline" class="field-full">
									<mat-label>Employee Code</mat-label>
									<input matInput placeholder="Employee Code" formControlName="empcode">
									<mat-error *ngIf="systemForm.get('empcode').errors">
										Code "{{ systemForm.get('empcode').value }}" is already in use for {{ empcodes[systemForm.get('empcode').value] | uppercase }}
									</mat-error>
								</mat-form-field>

								<div class="alert alert-info py-2 px-3 mb-3" *ngIf="isSalespersonSetupMode">
									Brand salespeople are created as sales managers (group level 2) so they can add their own reps in the sales portal.
								</div>

								<!-- Salesman Section -->
								<div *ngIf="systemForm.get('isSalesman')?.value && !isSalespersonSetupMode" class="salesman-section">

									<!-- Salesman code (in systemForm) -->
									<mat-form-field appearance="outline" class="field-full">
										<mat-label>Salesman Code</mat-label>
										<input matInput formControlName="salesman">
										<mat-hint *ngIf="systemForm.get('salesman')?.value">
											<mat-icon inline>info</mat-icon> A new salesman record will be created.
										</mat-hint>
										<mat-error>Required</mat-error>
									</mat-form-field>

									<!-- Salesman detail cards bound to salesForm -->
									<div [formGroup]="salesForm">
										<div class="salesman-cards-grid">

											<!-- Contact Info -->
											<div class="card mb-3">
												<div class="card-header">Contact Info</div>
												<div class="card-body">
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Manager</mat-label>
														<mat-select formControlName="manager">
															<mat-option value="">— None —</mat-option>
															<mat-option *ngFor="let m of managers" [value]="m.username">{{ m.salesmanname }} ({{ m.username }})</mat-option>
														</mat-select>
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Salesperson Name</mat-label>
														<input matInput formControlName="salesmanname" placeholder="Full display name">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Address</mat-label>
														<input matInput formControlName="smanaddr">
													</mat-form-field>
													<div class="field-row">
														<mat-form-field appearance="outline">
															<mat-label>City</mat-label>
															<input matInput formControlName="smancity">
														</mat-form-field>
														<mat-form-field appearance="outline">
															<mat-label>Region</mat-label>
															<mat-select formControlName="smanstate">
																<mat-option value="">—</mat-option>
																<mat-option *ngFor="let zone of zones?.zones" [value]="zone.code">{{ zone.code }}</mat-option>
															</mat-select>
														</mat-form-field>
														<mat-form-field appearance="outline">
															<mat-label>Zip</mat-label>
															<input matInput formControlName="smanzip">
														</mat-form-field>
													</div>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Tablet Number</mat-label>
														<input matInput formControlName="smantab">
													</mat-form-field>
												</div>
											</div>

											<!-- Commission Info -->
											<div class="card mb-3">
												<div class="card-header">Commission Info</div>
												<div class="card-body">
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Commission Rate 1 (%)</mat-label>
														<input matInput type="number" formControlName="commissionrate1" placeholder="e.g. 5.5">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Commission Rate 2 (%)</mat-label>
														<input matInput type="number" formControlName="commissionrate2">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Commission Break Point</mat-label>
														<input matInput type="number" formControlName="breakpoint">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>CSR Emails</mat-label>
														<input matInput formControlName="csremails" placeholder="Separate with commas">
													</mat-form-field>
												</div>
											</div>

											<!-- Control Info -->
											<div class="card mb-3">
												<div class="card-header">Control Info</div>
												<div class="card-body">
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Salesperson Type</mat-label>
														<mat-select formControlName="group_level">
															<mat-option *ngFor="let g of grouplevels" [value]="g.value">{{ g.name }}</mat-option>
														</mat-select>
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Include in Reports</mat-label>
														<mat-select formControlName="group_id">
															<mat-option value="1">Yes</mat-option>
															<mat-option value="2">No</mat-option>
														</mat-select>
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Enabled</mat-label>
														<mat-select formControlName="current">
															<mat-option value="1">Yes</mat-option>
															<mat-option value="0">No</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

											<!-- Credentials -->
											<div class="card mb-3">
												<div class="card-header">Credentials</div>
												<div class="card-body">
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Username</mat-label>
														<input matInput formControlName="username">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Login</mat-label>
														<input matInput formControlName="smanlogin">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Password</mat-label>
														<input matInput type="password" formControlName="smanpass">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Cell</mat-label>
														<input matInput formControlName="smancell">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Email</mat-label>
														<input matInput type="email" formControlName="smanemail">
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Portal Access Level</mat-label>
														<mat-select formControlName="access_level">
															<mat-option value="0">Standard</mat-option>
															<mat-option value="1">Admin</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

											<!-- Telegram -->
											<div class="card mb-3">
												<div class="card-header">Telegram</div>
												<div class="card-body">
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Chat ID</mat-label>
														<input matInput formControlName="chatid">
													</mat-form-field>
												</div>
											</div>

											<!-- Allowed brands (Moov portal or Summit rep restriction) -->
											<div class="card mb-3" *ngIf="showSalespersonBrandScope && brands?.length">
												<div class="card-header">Allowed brands</div>
												<div class="card-body">
													<p class="small text-muted">Brands this salesperson is allowed to sell (order entry and inventory).</p>
													<mat-form-field appearance="outline" class="field-full">
														<mat-label>Brands</mat-label>
														<mat-select formControlName="portal_manufacturer_ids" multiple (selectionChange)="onPortalBrandsChange()" (closed)="onPortalBrandsChange()">
															<mat-option *ngFor="let b of brands" [value]="b.manufacturer_id">{{ b.name }}</mat-option>
														</mat-select>
													</mat-form-field>
													<mat-form-field appearance="outline" class="field-full" *ngIf="(salesForm.get('portal_manufacturer_ids')?.value?.length || 0) > 0">
														<mat-label>Default brand for portal</mat-label>
														<mat-select formControlName="portal_default_manufacturer_id">
															<mat-option *ngFor="let mid of salesForm.get('portal_manufacturer_ids')?.value" [value]="mid">
																{{ portalBrandLabel(mid) }}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

										</div>
									</div>
								</div>

								<!-- Permissions -->
								<p class="subsection-label">Permissions</p>
								<div class="permissions-grid">
									<ng-container *ngFor="let perm of [
										{ label: 'Customer Admin', name: 'customeradmin' },
										{ label: 'Create Tender', name: 'cancreatetender' },
										{ label: 'Edit Invoice', name: 'editinv' },
										{ label: 'Dispatch Admin', name: 'dispatchadmin' },
										{ label: 'View Cost', name: 'viewcost' }
									]">
										<mat-form-field appearance="outline">
											<mat-label>{{ perm.label }}</mat-label>
											<mat-select formControlName="{{ perm.name }}">
												<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
											</mat-select>
										</mat-form-field>
									</ng-container>
								</div>
							</form>
							<div class="step-actions">
								<button mat-button matStepperPrevious>Back</button>
								<button mat-raised-button color="primary" matStepperNext [disabled]="!systemForm.valid">Next</button>
							</div>
						</mat-step>

						<!-- Step 3: Location Access -->
						<mat-step>
							<ng-template matStepLabel>Location Access</ng-template>
							<div class="locations-access-grid">
								<div class="location-column">
									<p class="subsection-label">Available</p>
									<mat-nav-list class="loc-list">
										<button mat-list-item *ngFor="let loc of locations" (click)="addUserLocation(loc)">
											<span class="loc-text"><strong>{{ loc.loccode }}</strong> {{ loc.locationname }}</span>
											<mat-icon class="loc-icon" color="primary">add_circle_outline</mat-icon>
										</button>
										<div *ngIf="!locations?.length" class="loc-empty">All locations assigned</div>
									</mat-nav-list>
								</div>
								<div class="location-column">
									<p class="subsection-label">Assigned <span class="loc-count" *ngIf="user.locations?.length">({{ user.locations.length }})</span></p>
									<mat-nav-list class="loc-list">
										<button mat-list-item *ngFor="let loc of user.locations" (click)="removeUserLocation(loc)">
											<span class="loc-text"><strong>{{ loc.loccode }}</strong> {{ loc.locationname }}</span>
											<mat-icon class="loc-icon" color="warn">remove_circle_outline</mat-icon>
										</button>
										<div *ngIf="!user.locations?.length" class="loc-empty">No locations assigned</div>
									</mat-nav-list>
								</div>
							</div>
							<div class="step-actions">
								<button mat-button matStepperPrevious>Back</button>
								<button mat-raised-button color="primary" class="create-btn"
										[disabled]="loading || !userForm.valid || !systemForm.valid || user.locations.length < 1"
										(click)="createUser()">
									<mat-spinner *ngIf="loading" diameter="18" strokeWidth="3"></mat-spinner>
									<span *ngIf="!loading">Create User</span>
								</button>
							</div>
						</mat-step>

					</mat-stepper>
				</div>

				<!-- Review Sidebar -->
				<div class="review-sidebar">
					<div class="review-section">
						<h5 class="review-section-title">User</h5>
						<dl class="review-list">
							<ng-container *ngFor="let field of [
								{ label: 'User ID', key: 'userid' },
								{ label: 'Name', key: 'realname' },
								{ label: 'Email', key: 'email' },
								{ label: 'Phone', key: 'phone' }
							]">
								<dt>{{ field.label }}</dt>
								<dd [class.missing]="!userForm.get(field.key).value"
									[class.error]="userForm.get(field.key).value && userForm.get(field.key).errors">
									{{ userForm.get(field.key).value || '—' }}
								</dd>
							</ng-container>
						</dl>
					</div>

					<div class="review-section">
						<h5 class="review-section-title">System</h5>
						<dl class="review-list">
							<dt>Default Location</dt>
							<dd [class.missing]="!systemForm.get('defaultlocation').value">{{ systemForm.get('defaultlocation').value || '—' }}</dd>
							<dt>Access Level</dt>
							<dd>{{ getAccessLevelName(systemForm.get('fullaccess').value) }}</dd>
							<dt>User Group</dt>
							<dd [class.missing]="!systemForm.get('user_group').value">{{ translate_usergroup(systemForm.get('user_group').value) || '—' }}</dd>
							<dt>Department</dt>
							<dd [class.missing]="!systemForm.get('department').value">{{ systemForm.get('department').value || '—' }}</dd>
							<dt>Customer Admin</dt>
							<dd>{{ translate_yn(systemForm.get('customeradmin').value) }}</dd>
							<dt>Create Tender</dt>
							<dd>{{ translate_yn(systemForm.get('cancreatetender').value) }}</dd>
							<dt>Edit Invoice</dt>
							<dd>{{ translate_yn(systemForm.get('editinv').value) }}</dd>
							<dt>Dispatch Admin</dt>
							<dd>{{ translate_yn(systemForm.get('dispatchadmin').value) }}</dd>
							<dt>View Cost</dt>
							<dd>{{ translate_yn(systemForm.get('viewcost').value) }}</dd>
						</dl>
					</div>

					<div class="review-section" *ngIf="systemForm.get('isSalesman')?.value">
						<h5 class="review-section-title">Salesman</h5>
						<dl class="review-list">
							<dt>Code</dt>
							<dd [class.missing]="!systemForm.get('salesman').value">{{ systemForm.get('salesman').value || '—' }}</dd>
							<dt>Name</dt>
							<dd [class.missing]="!salesForm.get('salesmanname').value">{{ salesForm.get('salesmanname').value || '—' }}</dd>
							<dt>Commission 1</dt>
							<dd>{{ salesForm.get('commissionrate1').value || '—' }}</dd>
							<dt>Type</dt>
							<dd>{{ salesForm.get('group_level').value }}</dd>
						</dl>
					</div>

					<div class="review-section">
						<h5 class="review-section-title">
							Locations
							<span class="loc-count" *ngIf="user.locations?.length">({{ user.locations.length }})</span>
						</h5>
						<dl class="review-list" *ngIf="user.locations?.length; else noLocs">
							<ng-container *ngFor="let loc of user.locations">
								<dt>{{ loc.loccode }}</dt>
								<dd>{{ loc.locationname }}</dd>
							</ng-container>
						</dl>
						<ng-template #noLocs>
							<p class="missing review-empty">No locations assigned yet</p>
						</ng-template>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>
